export enum SettingsLessonPhoneNavigationStyle {
  BUTTONS_WITH_TEXT = 'buttons_with_text',
  ARROWS_WITH_SUBMIT = 'arrows_with_submit',
  ARROWS = 'arrows'
}
